module.exports = __webpack_public_path__ + "img/PaymentOptions.8f5cc9f0.png";